$(function(){

  //smooth scroll on anchor click
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();

          document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth'
          });
      });
  });

  //this doesn't seem right. Everywhere else uses the "success" callback from CartJS
  $(document).on('cart.requestComplete', function(event, cart) {
    //get the top-most line item and add it to the sidecart
    sidecart.slide_out();
    sidecart.cartjs_add_this_product(cart.items[0])

  });


})



function pretty_price(price_cents){
  if (price_cents == 0) return 0
  if (!price_cents) return ""

  var price_dollars = price_cents / 100.0
  var decimal_part = price_dollars % 1

  if (decimal_part == 0)
    return price_dollars.toFixed(0)
  else
    return price_dollars.toFixed(2)
}


$(function(){
  toolkit.setup_sr();
  toolkit.scrollWatch();


  //set up accordion modules
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      this.classList.toggle("change");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
})



/*
  This is a toolkit that we use across several sites. Its fairly generic and includes things that
  usually come up in site dev
*/
const toolkit = {

  //for animating svgs
  path_prepare: function(e) {
    var lineLength = e.getTotalLength();
    $(e).css("stroke-dasharray", lineLength);
    $(e).css("stroke-dashoffset", lineLength);
  },


  //set a cookie
  set_cookie: function(name,value,days){
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  },

  //get a cookie
  get_cookie: function(name){
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  },

  //nuke a cookie
  erase_cookie: function(name){
    document.cookie = name+'=; Max-Age=-99999999;';
  },


  //get a query var
  get_query_variable: function(name){
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  //set a query var
  set_query_variable: function(key, value){
    var uri = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      var new_url = uri.replace(re, '$1' + key + "=" + value + '$2');
      history.replaceState ({path:new_url}, null, new_url);
    }
    else {
      var new_url = uri + separator + key + "=" + value;
      history.replaceState ({path:new_url}, null, new_url);
    }
  },

  //nuke a query var
  remove_query_variable: function(sParam){
    var url = window.location.href.split('?')[0]+'?';
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] != sParam) {
            url = url + sParameterName[0] + '=' + sParameterName[1] + '&'
        }
    }

    var new_url = url.substring(0,url.length-1);
    history.replaceState ({path:new_url}, null, new_url);
  },

  scrollWatch: function(){
    var lastScrollTop = 0;

    const element = document.getElementsByTagName("header");

    // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
    $(window).on("scroll", function(){ // or window.addEventListener("scroll"....
       var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
       if (st > lastScrollTop){
          $("header").removeClass("active");
       } else {
         $("header").addClass("active");
         $("header").addClass("bg-black");
       }
       lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);


  },


  setup_sr: function(){

  	$("*[reveal]").each(function(index,element){
      var delay = $(element).attr("data-delay") || 0;
      var direction = $(element).attr("data-direction") || "bottom"
      var duration = $(element).attr("data-duration") || 600
      var distance = $(element).attr("data-distance") || "0px"
      var reset = $(element).attr("data-reset") || false
      var scale = $(element).attr("data-scale") || 1

      var options = {
        distance: distance,
        origin: direction,
        duration: duration,
        delay: delay,
        viewFactor: 0.3,
        opacity:0,
        reset:reset,
        scale: scale,
        easing: 'ease-out'
      }
      ScrollReveal().reveal(element, options)
    })
  }
}
